import { ColorBox } from '../../Controls/ColorBox/ColorBox';
import Icon from '../../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import './style.scss';

interface Props {
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const MapZoom = (props: Props) => {
  return (
    <div className="map-zoom animate__animated animate__faster animate__fadeInRight">
      <ColorBox onSelect={props.onZoomIn} size={48} color={theme.colors.transparent}>
        <Icon size={18} name={Icons.Plus} />
      </ColorBox>
      <ColorBox onSelect={props.onZoomOut} size={48} color={theme.colors.transparent}>
        <Icon size={18} name={Icons.Minus} />
      </ColorBox>
    </div>
  );
};

export default MapZoom;
